var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendrier3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.48003 1C3.68879 1 3.85803 1.15498 3.85803 1.34616V2.04442C4.19332 2.03846 4.56915 2.03846 4.99201 2.03846H7.008C7.43085 2.03846 7.8067 2.03846 8.142 2.04442V1.34616C8.142 1.15498 8.3112 1 8.51995 1C8.72875 1 8.89795 1.15498 8.89795 1.34616V2.07504C9.6234 2.12824 10.0996 2.25879 10.4495 2.57919C10.7993 2.89959 10.9419 3.3357 11 4V4.5H1V4C1.05809 3.3357 1.20065 2.89959 1.55052 2.57919C1.90039 2.25879 2.37662 2.12824 3.10203 2.07504V1.34616C3.10203 1.15498 3.27127 1 3.48003 1Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11 7V6C11 5.5805 10.9936 4.83263 10.9872 4.5H1.0029C0.996445 4.83263 1.00279 5.5805 1.00279 6V7C1.00279 8.8856 1.00279 9.82845 1.58841 10.4142C2.17403 11 3.11657 11 5.00167 11H7.00112C8.88617 11 9.82872 11 10.4144 10.4142C11 9.82845 11 8.8856 11 7Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.25C9 8.6642 8.6642 9 8.25 9C7.8358 9 7.5 8.6642 7.5 8.25C7.5 7.8358 7.8358 7.5 8.25 7.5C8.6642 7.5 9 7.8358 9 8.25Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendrier3);
export default __webpack_public_path__ + "static/media/calendrier3.fae20e2335aac01f144e44ba09c1a9bc.svg";
export { ForwardRef as ReactComponent };